// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => MetadataFile.loadInternal(), entryList => {
        MetadataFile.θentryList.set(entryList)
        MetadataFile.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class MetadataFile {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label", "path", "hint", "mimeType"] as const,
        allPropertyNames: ["id", "label", "path", "hint", "mimeType"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<MetadataFile.Id | null>;
    static readonly Id = String;
    static ids: MetadataFile.Id[] = [] as any;
    static idsAndDisplayValues: Record<MetadataFile.Id, string> = {} as any;
    static θentryList = signal<MetadataFile.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<MetadataFile.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? MetadataFile.getEntryMap()[id]?.label : undefined
    });
    readonly θpath = computed(() => {
        const id = this.θid()
        return id !== null ? MetadataFile.getEntryMap()[id]?.path : undefined
    });
    readonly θhint = computed(() => {
        const id = this.θid()
        return id !== null ? MetadataFile.getEntryMap()[id]?.hint : undefined
    });
    readonly θmimeType = computed(() => {
        const id = this.θid()
        return id !== null ? MetadataFile.getEntryMap()[id]?.mimeType : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return MetadataFile[BoInfoSymbol]
    }

    get __type(): 'Toolbox.MetadataFile' {
        return 'Toolbox.MetadataFile'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.MetadataFile' {
        return 'Toolbox.MetadataFile'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): MetadataFile.Id | null {
        return this.θid()
    }

    set id(id: MetadataFile.Id | MetadataFile | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !MetadataFile.getEntry(id as MetadataFile.Id)) throw new Error('Invalid id for type Toolbox.MetadataFile: ' + id)
        this.θid.set(id as MetadataFile.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): MetadataFile.Id[] {
        return MetadataFile.ids
    }

    get idsAndDisplayValues(): Record<MetadataFile.Id, string> {
        return MetadataFile.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[MetadataFile.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get path() {
        return this.θpath()
    }

    get hint() {
        return this.θhint()
    }

    get mimeType() {
        return this.θmimeType()
    }

    get isProjects() {
        return this.id == 'projects'
    }

    static get Projects() {
        return new this('projects')
    }

    constructor(idOrObject: MetadataFile.Id | MetadataFile | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): MetadataFile.Entry[] {
        return This.MetadataFile.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): MetadataFile.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: MetadataFile.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof MetadataFile.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = MetadataFile.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<MetadataFile.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new MetadataFile(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: MetadataFile.Id | MetadataFile | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as MetadataFile.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: MetadataFile.Id | MetadataFile) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<MetadataFile.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.MetadataFile yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setProjects() {
        this.id = 'projects'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "projects", label: "Project list (CSV file)", path: "Projects.csv", hint: "Comma-separated CSV file that must contain at least columns \"Internal ID\" (number) and \"CTI Event\" (text). The column order doesn't matter", mimeType: "text/csv" })
        ] as MetadataFile.Entry[]) as MetadataFile.Entry[]
    }
}
jsonClass('Toolbox.MetadataFile')(MetadataFile)

export const MetadataFileθId = String;

export type MetadataFileθId = string;

export namespace MetadataFile {
    export type Id = 'projects'

    export interface Entry {
        id: MetadataFile.Id;
        label: string;
        path: string;
        hint: string;
        mimeType: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => MetadataFile.load(true))
